/**
 * widgets/notification-center/ui/NotificationCenter — Bell + dropdown composition.
 *
 * Wraps the NotificationBell trigger and NotificationDropdown in a Radix
 * DropdownMenu so that keyboard + screen-reader accessibility is handled
 * by the primitive.
 *
 * FSD: widgets may import from entities and shared only.
 */

import { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/shared/ui/dropdown-menu';
import { NotificationBell } from './NotificationBell';
import { NotificationDropdown } from './NotificationDropdown';

interface NotificationCenterProps {
  /** Called when the user clicks "View all" in the dropdown. */
  onViewAll: () => void;
}

export function NotificationCenter({ onViewAll }: NotificationCenterProps) {
  const [open, setOpen] = useState(false);

  function handleViewAll() {
    setOpen(false);
    onViewAll();
  }

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <span>
          <NotificationBell isOpen={open} onClick={() => setOpen((o) => !o)} />
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-80 p-0"
        aria-label="Notifications"
      >
        <NotificationDropdown onViewAll={handleViewAll} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
